export default __webpack_public_path__ + "static/media/footer-logo.1921dd4d.svg";